<template>
    <div class="property-selections">
        <PropertyDetailsModal :show_property.sync="modals.show_property" :project="selectedProperty" :is_proposal="is_proposal"/>
        <div v-if="!Object.keys(selected_project).length">
            <b-row>
                <b-col cols="12">
                    <div class="d-flex justify-content-between w-100 align-items-center">
                        <div>
                            <base-input
                                v-model="search_project"
                                prepend-icon="fas fa-search"
                                placeholder="Search"
                                >
                            </base-input>
                        </div>
                        <div class="text-right">
                            <el-switch
                                v-model="show_available_only"
                                class="mx-2"
                                active-color="#0BC196">
                            </el-switch>
                            Only show available projects
                        </div>
                    </div>
                </b-col>

                <b-col cols="12" v-loading="loading">
                    <el-tabs v-model="current_project">
                        <el-tab-pane v-for="projectSource in filteredProjectSources" :label="projectSource.label" :name="projectSource.name" :key="projectSource.name">
                            <el-tabs v-model="current_tab">
                                <el-tab-pane v-for="tab in tabs" :label="tab.label" :name="tab.name" :key="tab.name">
                                    <b-row>
                                        <b-col v-for="(project, index) in getProjectsByStage(tab.stageId, projectSource.name)" :key="index" cols="12" md="4">
                                            <b-card no-body class="p-2 cursor-pointer"  @click="togglePropertyDetails(project)">
                                                <div class="d-flex align-items-center mb-2">
                                                    <el-image
                                                        style="width: 80px; height: 80px"
                                                        class="rounded mr-2"
                                                        :src="project.project_cover_image"
                                                        fit="cover"
                                                    ></el-image>
                                                    <b-row>
                                                        <b-col cols="12">
                                                            <el-tooltip :content="project.project_name">
                                                                <p>{{ project.project_name | shortenText(20) }}</p>
                                                            </el-tooltip>
                                                            <el-tooltip :content="project.project_location">
                                                                <p class="text-xs text-muted">{{ project.project_location | shortenText(27) }}</p>
                                                            </el-tooltip>
                                                            <p class="font-weight-600" v-if="project.unit_lowest && project.unit_highest">RM{{ project.unit_lowest.unit_price | moneyFormatter }} - RM{{ project.unit_highest.unit_price | moneyFormatter  }}</p>
                                                        </b-col>
                                                    </b-row>
                                                </div>
                                                <div class="text-xs">
                                                    <span class="text-success" v-if="project.project_status === 'Available'">Available </span>
                                                    <span class="text-danger" v-else>Expired</span>
                                                    <span> | 
                                                        <span v-if="project.project_stage_id === 1">Under Construction</span>
                                                        <span v-else-if="project.project_stage_id === 3">Sub Sale</span>
                                                        <span v-else-if="project.project_stage_id === 4">For Rent</span>
                                                        <span v-else>Completed</span>
                                                    </span> 
                                                </div>
                                            </b-card>
                                        </b-col>
                                    </b-row>
                                </el-tab-pane>
                            </el-tabs>
                        </el-tab-pane>
                    </el-tabs>
                </b-col>
            </b-row>
        </div>
        <div v-else>
            <PropertyDetails :selected_project="selected_project" :is_proposal="is_proposal" @back="clearSelectedProperty"/>
        </div>
    </div>
</template>
<script>
import { Image, Switch, Tabs, TabPane } from 'element-ui'
import PropertyDetailsModal from '@/views/CustomerProfile/CustomerModals/SolutionScenarioModals/PropertyDetailsModal'
import PropertyDetails from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/PropertySolution/PropertyDetails'
import { mapActions, mapState } from 'pinia'
import { usePMPStore } from '@/stores/pmpStore'
import { useProductStore } from '@/stores/productStore'
import { useHestiaStore } from '@/stores/hestiaStore'
import { useAuthStore } from '@/stores/authStore'

export default {
    props: {
        is_proposal:{
            type: Boolean,
            default: false
        }
    },
    components: {
        PropertyDetailsModal,
        PropertyDetails,
        [Image.name]: Image,
        [Switch.name]: Switch,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    data() {
        return {
            projects: [],
            show_available_only: true,
            modals: {
                show_property: false
            },
            selectedProperty: null,
            search_project: '',
            current_tab: 'completed',
            current_project: 'HESTIA',
            projectSources: [
                { label: 'Kohata - PMP', name: 'PMP'},
                { label: 'Hestia', name: 'HESTIA'},
            ],
            tabs: [
                { label: 'Under Construction', name: 'under-construction', stageId: 1 },
                { label: 'Completed', name: 'completed', stageId: 2 },
                { label: 'Sub-sales', name: 'sub-sales', stageId: 3 },
                { label: 'Rental Unit', name: 'rental-unit', stageId: 4 },
            ],
            loading: true
        }
    },
    computed:{
        ...mapState(useAuthStore, ['auth_user']),
        ...mapState(usePMPStore, ['pmp_projects']),
        ...mapState(useProductStore, ['selected_project']),
        filteredProjectSources() {
            if (this._gAuth.appCode() === 'vps-v2') {
                return this.projectSources.filter(source => source.name !== 'PMP');
            }
            return this.projectSources;
        },
        projectAvailables(){
            let projects = this.getPMPProjectsByBank(this.$route.query.bank_code ?? null)
            if(this.show_available_only){
                projects = !_gHlp.isEmpty(projects) ? projects.filter((item) => item.project_status === 'Available') : [];
            }
            if(this.search_project){
                projects = !_gHlp.isEmpty(projects) ? projects.filter((item) => item.project_name.toLowerCase().includes(this.search_project.toLowerCase())) : []
            }

           projects.forEach(project => {
                if (project.project_name.includes('Subsales')) {
                    // Change project_stage_id if project name contains 'Subsales'
                    project.project_stage_id = 3; // or any other desired value
                }
            })

            return [...projects]
        },
    },
    watch: {
        pmp_projects: {
            handler(newVal) {
                if (newVal.length > 0) {
                    this.loading = false
                }
            },
            immediate: true,
        },
    },
    methods: {
        ...mapActions(usePMPStore, ['getPMPProjects', 'getPMPProjectsByBank', 'getProjectById']),
        ...mapActions(useProductStore, ['setSelectedProperty', 'clearSelectedProperty']),
        ...mapActions(useHestiaStore, ['getHestiaProjectCommission']),
        getProjectsByStage(stageId, source) {
            return this.projectAvailables.filter(project => 
                project.project_stage_id === stageId && project.project_source_type == source
            )
        },
        clearSelectedProp() {
            this.clearSelectedProperty()
        },
        async togglePropertyDetails(property) {
            if (!_gHlp.isEmpty(property)) {
                let project = await this.getProjectById(_gHlp.getValue(property, 'project_id'), _gHlp.getValue(property, 'project_source_type'))
                // only for hestia project, check if the unit assign to this active user, if got, change status from locked to open
                if(property.project_source_type == 'HESTIA') {
                    // get data from hestia project commission table
                    let hestiaProjectCommission = await this.getHestiaProjectCommission(_gHlp.getValue(property, 'project_id'))
                    if(_gHlp.getValue(hestiaProjectCommission, 'individual_setting')) {
                        let filteredUserCommission = hestiaProjectCommission.individual_setting.find(item => 
                            this.auth_user.parent_ids && 
                            item.user_ids && 
                            item.user_ids.some(userId => this.auth_user.parent_ids.includes(userId))
                        );
                        if(!_gHlp.isEmpty(filteredUserCommission)) {
                            let unit_ids = filteredUserCommission.unit_ids
                            project.data.data.unit_listing_group_by_level.forEach(level => {
                                level.forEach(item => {
                                    // check if the current item's unitno_id is in the unit_ids array
                                    if(unit_ids.includes(item.unitno_id)) {
                                        if(item.available_status == 'Locked') {
                                            item.available_status = 'Open'
                                        }
                                    }
                                })
                                
                            })
                        }
                    }
                }
                this.setSelectedProperty(project.data.data)
            } else {
                this.selectedProperty = null
            }
        },
        
    },
}
</script>